import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Icono } from './Icono';
import type { NombreIcono } from './iconos';

/**
 * Botón del panel (componentes.md §6): principal rojo, secundario blanco con borde, destructivo (rojo, al final y con
 * confirmación) y fantasma. Siempre icono + verbo; alto 44 (48 en móvil). Ocupado: el icono gira (`loader-circle`) y el
 * texto pasa al gerundio que se le dé. Toda zona táctil mide 44 × 44 como mínimo.
 */
export type TipoBoton = 'principal' | 'secundario' | 'destructivo' | 'fantasma';

const CLASE: Record<TipoBoton, string> = { principal: 'rv-b-pri', secundario: 'rv-b-sec', destructivo: 'rv-b-des', fantasma: 'rv-b-fan' };

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
    tipo?: TipoBoton;
    icono?: NombreIcono;
    /** Icono después del texto (p. ej. «Continuar →»). */
    iconoDetras?: boolean;
    /** Gesto del icono con ratón: girar (Reintentar) o avanzar (flechas). */
    gesto?: 'gira' | 'avanza';
    movil?: boolean;
    ocupado?: boolean;
    ocupadoTexto?: string;
    /** Rojo sobre secundario (acciones destructivas en la línea de una lista). */
    rojo?: boolean;
    children: ReactNode;
}

export function Boton({ tipo = 'principal', icono, iconoDetras = false, gesto, movil = false, ocupado = false, ocupadoTexto, rojo = false, className, children, disabled, ...resto }: Props) {
    const clases = ['rv-b', CLASE[tipo], movil ? 'rv-b--movil' : '', rojo ? 'rv-b-rojo' : '', className ?? ''].filter((c) => c !== '').join(' ');
    const dibujo = ocupado ? (
        <Icono nombre="loader-circle" tamano={18} className="rv-gira" />
    ) : icono === undefined ? null : (
        <Icono nombre={icono} className={gesto === undefined ? undefined : `rv-gesto-${gesto}`} />
    );
    return (
        <button type="button" className={clases} disabled={disabled === true || ocupado} aria-busy={ocupado ? true : undefined} {...resto}>
            {!iconoDetras && dibujo}
            <span>{ocupado && ocupadoTexto !== undefined ? ocupadoTexto : children}</span>
            {iconoDetras && dibujo}
        </button>
    );
}
